var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBonuses = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bonuses_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.396.599C3.365.594 2.362 1.573 2.82 2.79H1.091a1.1 1.1 0 0 0-.771.315 1.07 1.07 0 0 0-.32.761v1.076c0 .143.057.28.16.38a.55.55 0 0 0 .386.158h4.909V3.866h1.091V5.48h4.909a.55.55 0 0 0 .386-.158.54.54 0 0 0 .16-.38V3.866a1.07 1.07 0 0 0-.319-.761 1.1 1.1 0 0 0-.771-.315H9.18c.638-1.76-1.762-3.003-2.869-1.485L6 1.713l-.311-.42C5.345.815 4.871.605 4.396.599m-.033 1.114a.54.54 0 0 1 .387.92.55.55 0 0 1-.933-.382c0-.143.057-.28.16-.38a.55.55 0 0 1 .386-.158m3.273 0a.54.54 0 0 1 .387.92.55.55 0 0 1-.933-.382c0-.143.057-.28.16-.38a.55.55 0 0 1 .386-.158M.545 6.018v4.305a1.07 1.07 0 0 0 .32.761 1.1 1.1 0 0 0 .771.315h8.727a1.1 1.1 0 0 0 .771-.315 1.07 1.07 0 0 0 .319-.761V6.018H6.545v4.305h-1.09V6.018z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bonuses_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgBonuses;